import { CustomOperation } from "lib/types/generated/graphql-types"
import { Common } from "lib/types"
import esb from "elastic-builder"
import { theme } from "../../theme"


export const getFormattedOperation = (operation: CustomOperation) => {
  switch (operation) {
    case CustomOperation.Delivery:
      return "Deliveries"
    case CustomOperation.Cancellation:
      return "Cancellations"
    case CustomOperation.Refund:
      return "Refunds"
    case CustomOperation.Compensation:
      return "Compensations"
    case CustomOperation.Release:
      return "Releases"
    case CustomOperation.ModifyOrderAddresses:
      return "Address"
    case CustomOperation.ModifyOrderLines:
      return "Order line"
    case CustomOperation.ModifyShippingFees:
      return "Shipping fee"
  }
}

export const formatOperationToInput = (operation: CustomOperation) => {
  switch (operation) {
    case CustomOperation.Delivery:
      return "Delivery"
    case CustomOperation.Cancellation:
      return "Cancellation"
    case CustomOperation.Refund:
      return "Refund"
    case CustomOperation.Compensation:
      return "Compensation"
    case CustomOperation.Release:
      return "Release"
    case CustomOperation.ModifyOrderLines:
      return "OrderLinesModification"
    case CustomOperation.ModifyShippingFees:
      return "ShippingFeesModification"
    case CustomOperation.ModifyOrderAddresses:
      return "AddressesModification"
  }
  return ""
}



export const getOperationsQuery = (filter: Common.OrderOperationsFilter) => {
  const boolQuery = esb.boolQuery()

  boolQuery.mustNot(esb.existsQuery("completed"))

  if (filter.storeGroups.length > 0) {
    boolQuery.must(esb.termsQuery("storeGroupId", filter?.storeGroups))
  }

  if (filter.countryCodes.length > 0) {
    boolQuery.must(esb.termsQuery("countryCode", filter?.countryCodes))
  }

  if (filter.operations.length > 0) {
    boolQuery.must(
      esb.termsQuery(
        "type",
        filter?.operations.map((operation) => formatOperationToInput(operation))
      )
    )
  }

  return boolQuery
}

export const OPERATION_KEYS = ["Delivery", "Cancellation", "Refund", "Release", "Compensation", "OrderLinesModification", "ShippingFeesModification", "AddressesModification"] as const

export const operationStrokeColors: Record<string, string> = {
  Delivery: theme.colors.delivery.stroke,
  Cancellation: theme.colors.cancellation.stroke,
  Refund: theme.colors.refund.stroke,
  Release: theme.colors.release.stroke,
  Compensation: theme.colors.compensation.stroke,
  OrderLinesModification: theme.colors.orderLines.stroke,
  ShippingFeesModification: theme.colors.shippingFees.stroke,
  AddressesModification: theme.colors.addresses.stroke
}

 export const operationFillColors: Record<string, string> = {
  Delivery: theme.colors.delivery.fill,
  Cancellation: theme.colors.cancellation.fill,
  Refund: theme.colors.refund.fill,
  Release: theme.colors.release.fill,
  Compensation: theme.colors.compensation.fill,
  OrderLinesModification: theme.colors.orderLines.fill,
  ShippingFeesModification: theme.colors.shippingFees.fill,
  AddressesModification: theme.colors.addresses.fill
}
